export const APPLE_BUTTON_CONTINUE = "Continue with Apple";
export const APPLE_BUTTON_SIGN_UP = "Sign Up with Apple";
export const APPLE_BUTTON_DISCONNECT = "Disconnect Apple Account";
export const APPLE_BUTTON_CONNECT = "Connect Apple Account";
